import React, {useState, useEffect} from "react";
import {VsiBubble, VsiH4, VsiP} from "../../../styled/App.styled";
import {useAuthWithRoute, useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {Card} from "reactstrap";
import Grid from "../../../components/Grid";
import {backupPoolTrends} from "../../../utils/gridColumnDefs/backups/backupPoolTrends";
import Stockchart from "../../../components/Stockchart";
import {formatStockChartConfig} from "../../../utils/Helpers";
import VsiLabeledSelect from "../../../components/VsiLabeledSelect";

export default function BackupPoolTrend({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const {theme, client, periodId} = useVsiAppContext();

    const defaultPoolValLabel = {pool: '', device: '', label: ''}
    const [trendData, setTrendData] = useState([]);
    const [chartConfig, setChartConfig] = useState({});
    const [gridData, setGridData] = useState([]);
    const [poolSelection, setPoolSelection] = useState(defaultPoolValLabel);
    const [poolList, setPoolList] = useState([defaultPoolValLabel]);
    const [poolTrend, {isLoading: isPoolLoading}] = useAuthWithRoute(`/api/v6/report/backup_trends_by_pool_proc?client_id=${client.clientId}&period_id=${periodId}&device_name=${poolSelection.device}&pool_name=${poolSelection.pool}`);

    const onPoolSelectionChange = async (option) => {
        setTrendData([]);
        setPoolSelection(option);
        // reFetchPoolData();
    };

    function initiatePoolList() {
        const transformedData = poolTrend?.recordsets?.[1]?.map?.(item => {
            return {
                pool: item.pool_name,
                device: item.device_name,
                label: `${item.device_type_code} - ${item.device_name} - ${item.pool_name}`
            };
        }) || [];
        if (transformedData.length > 0) {
            setPoolSelection(transformedData[0]);
            setPoolList(transformedData);
        } else {
            setPoolList([defaultPoolValLabel]);
        }
    }

    useEffect(() => {
        if (!isPoolLoading) {
            if (poolList.length === 1 && poolList[0].pool === '') {
                initiatePoolList();
            }
            handleStateWithData(poolTrend?.recordsets?.[0] || [])
            setGridData(poolTrend?.recordsets?.[0] || [])
        }
    }, [poolTrend, poolSelection]);


    const handleStateWithData = data => {
        const config = formatStockChartConfig(data || [], [
            {
                name: 'Used',
                field: 'pool_used'
            },
            {
                name: 'Free',
                field: 'pool_free'
            },
            {
                name: 'Usable',
                field: 'pool_total'
            },
            {
                name: 'Allocated',
                field: 'pool_allocated'
            }
        ]);
        setChartConfig({
            yAxis: [
                {
                    title: {
                        text: 'GiB',
                    }
                }
            ]
        });
        setTrendData(config.series);
    };

    const filterChanged = (eventData) => {
        let rowData = [];
        eventData.api.forEachNodeAfterFilter(node => {
            rowData.push(node.data);
        });
        handleStateWithData(rowData || []);
    };

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Backup Pool Trend</VsiH4>
            <VsiBubble noAutobot>
                <VsiLabeledSelect
                    options={poolList}
                    isLoading={isPoolLoading}
                    isDisabled={isPoolLoading}
                    label={'Select Device - Pool'}
                    minWidth={200}
                    maxWidth={600}
                    onChange={onPoolSelectionChange}
                    defaultValue={poolSelection}
                />
            </VsiBubble>
            {gridData.length === 0 ? (<VsiP>(No trend record)</VsiP>) : null}
            <VsiBubble>
                <Stockchart
                    series={trendData}
                    config={chartConfig}
                    formatData={'{point.y:,.0f}'}
                    formatPoint={'{series.name}: <b>{point.y:,.0f}</b>'}
                />
            </VsiBubble>
            <VsiBubble>
                <Grid addStyle data={gridData}
                      filterChanged={filterChanged}
                      columnDefs={backupPoolTrends}
                      isLoading={isPoolLoading}/>
            </VsiBubble>
        </Card>
    )
}
